// extracted by mini-css-extract-plugin
export var colorSquare = "_tt-0";
export var danger = "_tt-5";
export var lightPink = "_tt-8";
export var neutralBlue = "_tt-7";
export var neutralYellow = "_tt-6";
export var normal = "_tt-1";
export var primary = "_tt-2";
export var primaryLight = "_tt-3";
export var solidBlack = "_tt-g";
export var solidGreen = "_tt-b";
export var solidLightBlue = "_tt-d";
export var solidNavy = "_tt-c";
export var solidOrange = "_tt-f";
export var solidPink = "_tt-e";
export var solidRed = "_tt-9";
export var solidYellow = "_tt-a";
export var success = "_tt-4";